(function () {
  'use strict';

  function initGallery(root) {
    var main = root.querySelector('[data-pgf-main]');
    var thumbs = root.querySelector('[data-pgf-thumbs]');
    if (!main || !thumbs || !window.Flickity) return;

    var flkty = new Flickity(main, JSON.parse(main.getAttribute('data-flickity') || '{}'));

    thumbs.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-index]');
      if (!btn) return;
      var index = parseInt(btn.getAttribute('data-index'), 10);
      flkty.select(index);
    });

    function setActiveThumb(i) {
      thumbs.querySelectorAll('.pgf__thumb').forEach(function (el, idx) {
        el.classList.toggle('is-active', idx === i);
      });
    }
    setActiveThumb(flkty.selectedIndex);

    flkty.on('select', function () {
      setActiveThumb(flkty.selectedIndex);
      // ARIA для доступності
      main.querySelectorAll('.pgf__cell').forEach(function (cell, idx) {
        cell.setAttribute('aria-hidden', idx === flkty.selectedIndex ? 'false' : 'true');
      });
    });

    document.addEventListener('product:variant-change', function (evt) {
      var variant = evt.detail && evt.detail.variant;
      if (!variant || !variant.featured_media || !variant.featured_media.id) return;

      var mediaId = String(variant.featured_media.id);
      var cells = main.querySelectorAll('.pgf__cell');
      var index = Array.prototype.findIndex.call(cells, function (cell) {
        return String(cell.getAttribute('data-media-id')) === mediaId;
      });
      if (index >= 0) flkty.select(index);
    });

    document.addEventListener('variant:changed', function (evt) {
      var variant = evt.detail && evt.detail.variant;
      if (!variant || !variant.featured_media || !variant.featured_media.id) return;
      var mediaId = String(variant.featured_media.id);
      var cells = main.querySelectorAll('.pgf__cell');
      var index = Array.prototype.findIndex.call(cells, function (cell) {
        return String(cell.getAttribute('data-media-id')) === mediaId;
      });
      if (index >= 0) flkty.select(index);
    });
  }

  function boot() {
    document.querySelectorAll('.pgf').forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
